import GalleryFilterItem from './GalleryFilterItem';
import { ColorFilter } from '@root/src/partials/visualizer';

export interface ToggleFilterCallback {
  (filter: FilterType): void;
}

export type FilterType = ColorFilter | string;

interface GalleryFilterProps {
  colors: ColorFilter[];
  colorFilters: ColorFilter[];
  toggleColorFilters: ToggleFilterCallback;
  styles: string[];
  styleFilters: string[];
  toggleStyleFilters: ToggleFilterCallback;
  categories: string[];
  categoryFilters: string[];
  toggleCategoryFilters: ToggleFilterCallback;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & GalleryFilterProps>;

const GalleryFilter: Props = ({ children, ...props }) => {
  const {
    toggleColorFilters,
    colorFilters,
    colors,
    toggleStyleFilters,
    styleFilters,
    styles,
    toggleCategoryFilters,
    categoryFilters,
    categories,
    ...cleanedProps
  } = props;

  return (
    <div className="row space-y-16 sm:space-y-0" {...cleanedProps}>
      {styles.length > 0 && (
        <GalleryFilterItem title="Style" items={styles} itemFilters={styleFilters} toggleStyleFilters={toggleStyleFilters} />
      )}

      {colors.length > 0 && (
        <GalleryFilterItem title="Color" items={colors} itemFilters={colorFilters} toggleStyleFilters={toggleColorFilters} colorLabels />
      )}

      {categories.length > 0 && (
        <GalleryFilterItem title="Category" items={categories} itemFilters={categoryFilters} toggleStyleFilters={toggleCategoryFilters} />
      )}
    </div>
  );
};

export default GalleryFilter;
